import { Component } from '@angular/core';
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { UserDataService } from '../../../../core/services/user-data.service';

@Component({
  selector: 'app-logout-dialog',
  standalone: true,
  imports: [CustomButtonComponent, TranslocoPipe],
  templateUrl: './logout-dialog.component.html',
  styleUrl: './logout-dialog.component.css'
})
export class LogoutDialogComponent {
  modalDialogId: string = 'auth_modal_logout';
  private dialogResponsePromise!: (value: boolean) => void;

  get userName(): string {
    return this.userData.getUser()?.first_name ?? '';
  }

  constructor(private userData: UserDataService) { }

  openModal(): Promise<boolean> {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.showModal();

      return new Promise<boolean>((resolve) => { this.dialogResponsePromise = resolve; });
    }

    return Promise.resolve(false);
  }

  closeModal(dialogResponse: boolean): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      modal.close();
      this.dialogResponsePromise(dialogResponse);
    }
  }
}
